import axios from 'axios'
import { ServerEnv } from 'Configs/ServerEnv'
import StorePaymentStep from 'GlobalStores/Cores/Elements/StorePaymentStep'
import { ObjectHelpers } from 'Helpers/ObjectHelpers'
import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import Payment from '../Payment'
import States from 'Components/Elements/Forms/StatesModal/Country/MoroccoStates.json'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import storeCredit from 'GlobalStores/StoreCredit'
import StoreCheckout from '../StoreCheckout'
import { objectToQueryString } from 'Helpers/GlobalHelpers'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'

class Morocco {
    autoAddressDisplayKeys = ['street', 'locality', 'postal_code']
    autoAddressKeyToForm = {
        street: 'street_address',
        locality: 'city',
        administrative_area: 'state',
        postal_code: 'zip_code'
    }

    chainAddress = {
        isChainAddress: false,
        groupAddress: []
    }

    moroccoStates3letters = {
        'Béni Mellal-Khénifr': 'MA-05',
        'Bay of Plenty': 'BOP',
        Canterbury: 'CTB',
        'Chatham Islands Territory': 'CHT',
        Gisborne: 'GIS',
        "Hawke'S Bay": 'HKB',
        'Manawatu-Wanganui': 'MWT',
        Marlborough: 'MBH',
        Nelson: 'NSN',
        Northland: 'NTL',
        Otago: 'OTA',
        Southland: 'STL',
        Taranaki: 'TKI',
        Tasman: 'TAS',
        Waikato: 'WKO',
        Wellington: 'WGN',
        'West Coast': 'WTC'
    }

    uuid = ''
    selectedShippingPaymentOption = null

    toFormat = {
        enroll: {
            uuid: this.GetUuid(),
            address1: '',
            address2: '',
            city: '',
            zip: '',
            email: '',
            state: '',
            phone: '',
            password: '',
            shipment_options: 'delivery'
        },
        enrollWithReferral: {
            uuid: this.GetUuid(),
            // fullName: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            password1: '',
            password2: '',
            shipment_options: 'delivery'
        },
        shop: {
            uuid: this.GetUuid(),
            fullname: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            shipment_options: 'delivery' // [delivery, pickup, homedelivery]
        }
    }

    formShop = {
        fullName: '',
        email: '',
        phone: '',
        street_address1: '',
        city: '',
        state: '',
        zip_code: ''
    }

    createAccountWithShippingAddress = {
        type: 'enroll',
        referral_id: '',
        firstname_en: '',
        lastname_en: '',
        email: '',
        phone: '',
        password: '',
        confirm_password: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        period: '',
        shipment_options: 'delivery'
    }

    ExcludedFieldsShippingIfCreateAccount = ['fullName']

    ExcludedFieldsShipping = []

    mapFormKeyToFormatKey = {
        street_address1: 'address',
        fullName: 'fullname',
        zip_code: 'zip',
        firstname: 'firstname_en',
        lastname: 'lastname_en'
    }

    // ArrangeCreateCheckoutForm = ['firstname', 'lastname', 'email', 'password', 'phone', 'country', 'street_address', 'city', 'state', 'zip_code']
    ArrangeCreateCheckoutForm = [
        'firstname',
        'lastname',
        'email',
        'phone',
        'password',
        'confirm_password',
        'address1',
        'address2',
        'city',
        'state',
        'zip_code',
        'country'
    ]

    PaymentStep = {
        payment: 0,
        createOrder: 0,
        autoship: -2,
        updateLog: 0
    }

    breadcrumbOption = [
        {
            caption: 'customise',
            link: '/products',
            paramsRequire: false
        },
        {
            caption: 'signup_shipping',
            link: '/checkout/create-account',
            paramsRequire: true,
            authCaption: 'shipping',
            authLink: '/checkout/shipping'
        },
        {
            caption: 'purchase',
            link: '/checkout/payment',
            paramsRequire: true
        }
    ]
    // [delivery, pickup, homedelivery]
    shippingMethods = [
        {
            id: 1,
            api_value: 'pickup',
            title: 'pickup_casablanca_office',
            dict_key: 'pickup_casablanca_office',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'Credit card',
                    dict_key: 'creditcard',
                    for_status: []
                },
            ]
        },
        {
            id: 2,
            api_value: 'ctm',
            title: 'ctm_delivery_to_centers',
            dict_key: 'ctm_delivery_to_centers',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'creditcard',
                    dict_key: 'creditcard',
                    for_status: []
                },
                {
                    id: 2,
                    title: 'cash_on_delivery',
                    dict_key: 'cash_on_delivery',
                    // descripion: {
                    //     title: 'pay_when_you_receive',
                    //     dict_key: 'pay_when_you_receive'
                    // },
                    // for_status: ['M']
                    for_status: []
                }
            ]
        },
        {
            id: 3,
            api_value: 'homedelivery',
            title: 'home_delivery',
            dict_key: 'home_delivery',
            for_status: [],
            options: [
                {
                    id: 1,
                    title: 'creditcard',
                    dict_key: 'creditcard',
                    for_status: []
                },
                {
                    id: 2,
                    title: 'cash_on_delivery',
                    dict_key: 'cash_on_delivery',
                    // descripion: {
                    //     title: 'pay_when_you_receive',
                    //     dict_key: 'pay_when_you_receive'
                    // },
                    // for_status: ['M']
                    for_status: []
                }
            ]
        }
    ]

    PaymentGateway = 'hydra3ds'

    orderSummaryConfig = {
        subTotal: {
            display: true,
            dict_key: 'subtotal'
        },
        shipping: {
            display: true,
            dict_key: 'shipping',
            fromOrderCal: true
        },
        productCredit: {
            display: true,
            dict_key: 'product_credit',
            icon: false,
            allowToUse: [
                { status: 'A', value: 0.5 },
                { status: 'M', value: 1 }
            ],
        },
        vat: {
            display: false,
            dict_key: 'vat',
            value: 0.2 // 20%
        }
    }

    pageConfig = {
        login: {
            disable: false
        },
        signUp: {
            disable: true
        }
    }

    landingLayouts = [
        {
            nameComponent: 'banner',
            titleContent: 'mainBanner',
            style: {}
        },
        {
            nameComponent: 'ourApproach',
            titleContent: 'ourApproach',
            style: {
                minHeight: '0px'
            }
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {
                backgroundColor: '#F1F6FB'
            }
        },
        {
            nameComponent: 'thePractice',
            titleContent: 'thePractice',
            style: {}
        },
        {
            nameComponent: 'howItWorks',
            titleContent: 'howItWorks',
            style: {
                backgroundColor: '#FBF7F1'
            }
        },
        {
            nameComponent: 'whatExpertsSay',
            titleContent: 'expertsSay',
            style: {}
        },
        {
            nameComponent: 'realResults',
            titleContent: 'realResults',
            style: {
                backgroundColor: '#F2F9F8'
            }
        }
    ]

    productLayouts = [
        {
            nameComponent: 'productDetailSelection',
            titleContent: 'productDetailSelection',
            style: {}
        },
        {
            nameComponent: 'theProducts',
            titleContent: 'theProducts',
            style: {}
        },
        {
            nameComponent: 'frequentlyAskedQuestions',
            titleContent: 'questions',
            style: {
                backgroundColor: '#F6F9FC'
            }
        }
    ]

    MapAutoAddressToForm(form, autoAddressData) {
        const swappedValuesAsKeys = ObjectHelpers.swapKeysAndValues(this.autoAddressKeyToForm)
        return form.map(item => {
            if (swappedValuesAsKeys[item.key]) {
                if (autoAddressData.data) {
                    if (item.key === 'state') {
                        item.value = this.ConvertMoroccoFullNameStateToStateCode(autoAddressData.data[swappedValuesAsKeys[item.key]])
                    } else {
                        item.value = autoAddressData.data[swappedValuesAsKeys[item.key]]
                    }
                }
            }

            return item
        })
    }

    FormToFormat(type, form) {
        form.map(item => {
            if (this.mapFormKeyToFormatKey[item.key]) {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][this.mapFormKeyToFormatKey[item.key]] = item.value
                    })
                }
            } else {
                if (this.toFormat[type]) {
                    runInAction(() => {
                        this.toFormat[type][item.key] = item.value
                    })
                }
            }

            return item
        })
    }

    SetUuid(value) {
        this.uuid = value
    }

    GetUuid() {
        return this.uuid
    }

    GetFormat(type) {
        return this.toFormat[type]
    }

    GetPaymentStep() {
        return this.PaymentStep
    }

    GetBreadcrumbOption() {
        return this.breadcrumbOption
    }

    GetShippingMethod() {
        return this.shippingMethods
    }

    GetPageConfig() {
        return this.pageConfig
    }

    SetPaymentStep(key, value) {
        this.PaymentStep[key] = value
    }

    SpecialAreasDeliveryFeeCondition(a, b) {
        console.log('args', a, b)
    }

    ConvertMoroccoFullNameStateToStateCode(fullNameState) {
        return this.moroccoStates3letters[fullNameState]
    }

    StatesList() {
        let items = []
        States.map(raw => {
            items.push({
                text: raw.abbreviation,
                value: raw.name,
                html: `<span>${raw.name}</span>`
            })
        })
        return items
    }

    AddressOptionList(key) {
        let items = []
        States.map(raw => {
            items.push({
                text: raw,
                value: raw,
                html: `<span>${raw}</span>`
            })
        })
        return items
    }

    GetOrderSummaryConfig() {
        return this.orderSummaryConfig
    }

    SetSelectedShippingPaymentOption(value) {
        this.selectedShippingPaymentOption = value
    }

    GetSelectedShippingPaymentOption() {
        return this.selectedShippingPaymentOption
    }

    GetLandingLayout() {
        return this.landingLayouts
    }

    GetProductLayout() {
        return this.productLayouts
    }

    /**
     *
     * @param {*} uuid
     * @param {object} detailPage { products, detailPage, isSubscribe, isEnroll, type}
     * @param {*} CreditCardEncrypted
     */
    async SubmitPayment(uuid, detailPage, CreditCardEncrypted, billingAddressForm, products, options) {
        const Pay = new Payment(uuid, detailPage)
        try {
            const responsePreparePayment = await Pay.PreparePaymentData()

            const allowCreditEnable = StoreAuth.IsAllowCredit()

            if (!Pay.hydra.transactions) {
                Pay.hydra.transactions = {}
            }

            if (options.shippingPaymentOption.id === 1) {
                Pay.hydra.transactions = {
                    items: [
                        {
                            amount: options.totalPrice,
                            type: 'IOU',
                            method: 'CreditCard',
                            billToEmail: responsePreparePayment.data.data.hydra.shipToEmail,
                            billToPhone: responsePreparePayment.data.data.hydra.shipToPhone,
                            methodDetails: {
                                payer: responsePreparePayment.data.data.hydra.shipToName.firstName,
                                bankName: 'CMI'
                            }
                        }
                    ]
                }
            } else if (options.shippingPaymentOption.id === 2) {
                if (options.totalPrice > 0) {
                    Pay.hydra.transactions = {
                        items: [
                            {
                                amount: options.totalPrice,
                                type: 'IOU',
                                method: 'Cash'
                            }
                        ]
                    }
                } else {
                    Pay.hydra.transactions = { items: [] }
                }
            }

            if (allowCreditEnable && storeCredit.GetCreditData()?.creditUsed > 0) {
                // MAR
                const productCredit = storeCredit.GetCreditData()

                if (productCredit.creditType === 'cashCoupon') {
                    if (options.totalPrice - productCredit.creditUsed === 0) {
                        Pay.hydra.transactions = { items: [] }
                    } else {
                        Pay.hydra.transactions.items[0].amount -= productCredit.creditUsed
                    }

                    Pay.hydra.transactions.items.push({ ...storeCredit.cashCouponForm, amount: productCredit.creditUsed })
                }
                if (productCredit.creditType === 'arBalance') {
                    if (options.totalPrice - StoreCheckout.GetFinalARBalance() === 0) {
                        Pay.hydra.transactions = { items: [] }
                    } else {
                        Pay.hydra.transactions.items[0].amount -= StoreCheckout.GetFinalARBalance()
                    }

                    Pay.hydra.transactions.items.push({ ...storeCredit.arBalanceForm, amount: StoreCheckout.GetFinalARBalance() })
                }

                // Pay.hydra.transactions.items.push(storeCredit.ProductCreditUsed())
            }

            await Pay.PostToHydra()
            await Pay.UpdateCMILog()

            return {
                success: true,
                payment_id: responsePreparePayment.data.data.payment_id,
                orderData: Pay.orderData
            }
        } catch (error) {
            console.log(error)
            runInAction(() => {
                StorePaymentStep.PaymentDone = true
            })
            Pay.UpdateToLog(Pay.hydra.transactions, 0, true)
            return { success: false }
        }
    }

    async CreateAccount(uuid, accForm, shippingForm, referral, cartItems) {
        try {
            const forms = Object.assign(this.createAccountWithShippingAddress, accForm)

            const returnShippingAddress = {}
            shippingForm.map(item => {
                if (this.ExcludedFieldsShippingIfCreateAccount.includes(item.key)) {
                    return false
                }
                if (this.mapFormKeyToFormatKey[item.key]) {
                    forms[this.mapFormKeyToFormatKey[item.key]] = item.value.trim()
                    returnShippingAddress[this.mapFormKeyToFormatKey[item.key]] = item.value.trim()
                } else {
                    forms[item.key] = item.value.trim()
                    returnShippingAddress[item.key] = item.value.trim()
                }
            })

            if (referral) {
                forms.referral_id = referral
            } else {
                delete forms.referral_id
            }

            delete forms.country

            if (forms.password !== forms.confirm_password) {
                return {
                    success: false,
                    passwordDidNotMatch: true
                }
            }

            if (!StoreCheckout.shippingMethod) {
                return {
                    success: false,
                    shippingMethodIsRequired: true
                }
            }

            const periodResponse = await FeelGreatAPI.GetPeriod('MA')
            forms.period = periodResponse.data.entryPeriod
            forms.uuid = uuid
            forms.shipment_packs = JSON.stringify(cartItems)
            if (StoreCheckout.shippingMethod) {
                forms.shipment_options = StoreCheckout.shippingMethod.api_value
            }

            const queryStrings = objectToQueryString({
                dev: ServerEnv.ENV === 'DEV' ? '1' : undefined,
                emailDelay: ServerEnv.ENV === 'DEV' ? undefined : '1h',
                isSkipCheckPassword: storeFeelGreat.passwordSettings.isUseComplexPassword ? '1' : undefined,
            })

            const url = `https://${ServerEnv.MemberCalls2()}.unicity.com/hot/formatV2/MAR/feelGreat/createAccount${queryStrings}`

            const response = await axios.post(url, forms)

            return {
                ...response.data,
                form: forms
            }
        } catch (e) {
            console.error(e)

            return {
                success: false
            }
        }
    }

    constructor() {
        StorePaymentStep.SetPaymentSteps(this.PaymentStep)
        makeAutoObservable(this)
    }
}

export default Morocco
